import {
  AppHeader,
  AppSidebar,
  SidebarInset,
  SidebarProvider,
} from "@/components";
import { useProfileQuery } from "@/hooks/api/profile.queries";
import { getProfilePhotoUrl } from "@/services/profile.service";
import { Outlet } from "react-router-dom";

const AppLayout = () => {
  // TODO: Replace with actual notification count from API/store
  const notificationCount = 3;

  const { data: profile } = useProfileQuery();
  
  const userName = profile?.full_name || "Student";
  const userEmail = profile?.org_email || profile?.personal_email || "student@college.edu";
  const profilePhotoUrl = getProfilePhotoUrl(profile?.profile_photo_url || null, 'sm');

  const handleSearch = (query: string) => {
    // TODO: Implement global search functionality
    console.log("Global search:", query);
  };

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="h-screen overflow-hidden">
        <AppHeader
          onSearch={handleSearch}
          notificationCount={notificationCount}
          userName={userName}
          userEmail={userEmail}
          profilePhotoUrl={profilePhotoUrl}
        />
        <main className="scrollbar-thin min-h-0 flex-1 overflow-auto p-4">
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
};

export default AppLayout;
